import { BaseService } from '@/services/base.service'

export class CalculateSalaryServices extends BaseService {
  static get entity() {
    return '/payslip/calculate-salary';
  }
}
